const $ = jQuery.noConflict();

'use strict';
const compareBar = document.querySelector('.js-products-compare__bar');
let compareIds = compareBar ? compareBar.getAttribute('data-ids').split('|') : [];
compareIds = compareIds.filter(function(el) {
	return el !== null && el !== '';
});
const CompareProducts = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.compareTrigger();
		// this.preselectCheckboxes();
		this.removeFromCompareBar();
		if (document.body.classList.contains('page-template-page-compare-products')) {
			CompareProducts.removeSingleProduct();
			CompareProducts.removeAll();
		}
		// $(document).on('sf:ajaxfinish', '.searchandfilter', function() {
		// 	// CompareProducts.removeFromCompareBar();
		// 	CompareProducts.compareTrigger();
		// });
		// $(document).ajaxStop(function() {
		// 	CompareProducts.compareTrigger();
		// });
	},

	compareTrigger: function() {
		const checkboxes = document.querySelectorAll('.js-product-box__icon-compare input[type="checkbox"]');

		if (!checkboxes) {
			return false;
		}

		const getCompareIds = function(e) {
			const ele = e.currentTarget;
			const id = ele.getAttribute('data-id');
			if (ele.checked) {
				ele.parentElement.classList.add('checked');
				// add to array
				if (!compareIds.includes(id) && compareIds.length < 5) {
					compareIds.push(id);
				}
			} else {
				ele.parentElement.classList.remove('checked');
				// remove from array
				const index = compareIds.indexOf(id);
				compareIds.splice(index, 1);
			}
			CompareProducts.compareMaxAllowed();
			document.body.classList.add('ajax-custom-action');
			CompareProducts.ajaxFunction();
		};

		for (let i = 0; i < checkboxes.length; i++) {
			checkboxes[i].addEventListener('click', getCompareIds);
		}
	},

	preselectCheckboxes: function() {
		if (compareIds.length < 1) {
			return false;
		}
		if (compareIds.length > 0) {
			for (let i = 0; i < compareIds.length; i++) {
				const element = $(`.js-product-box__icon-compare input[data-id="${compareIds[i]}"]`);
				if (element) {
					element.prop('checked', true);
					element.parent().addClass('checked');
				}
			}
		}
		CompareProducts.compareMaxAllowed();
	},

	compareMaxAllowed: function() {
		if (compareIds.length < 1) {
			return false;
		}
		const allNonCheckedInputs = $('.js-product-box__icon-compare:not(.checked)');
		if (compareIds.length === 4) {
			allNonCheckedInputs.addClass('disabled');
		} else {
			allNonCheckedInputs.removeClass('disabled');
		}
	},

	removeFromCompareBar: function() {
		const buttons = document.querySelectorAll('.js-products-compare__bar-list-close');

		if (buttons.length < 1) {
			return false;
		}

		const triggerRemoveCompare = function(e) {
			const ele = e.currentTarget;
			const id = ele.getAttribute('data-id');
			// if (!id) {
			// 	return false;
			// }

			const productInput = document.querySelector(`.js-product-box__icon-compare.checked input[data-id="${id}"]`);
			if (productInput) {
				productInput.click();
			} else {
				const data = {
					action: 'remove_single_compare',
					id
				};
				document.body.classList.add('ajax-custom-action');
				CompareProducts.ajaxFunctionRemove(data);
			}

			// if is compare page
			const productCloseBtn = document.querySelector(`.js-compare-block__bottom-box-close-icon[data-id="${id}"]`);
			if (productCloseBtn) {
				productCloseBtn.click();
			}
		};

		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', triggerRemoveCompare);
		}
	},

	removeSingleProduct: function() {
		const buttons = document.querySelectorAll('.js-compare-block__bottom-box-close-icon');

		if (buttons.length < 1) {
			return false;
		}

		const removeSingle = function(e) {
			const ele = e.currentTarget;
			const id = ele.getAttribute('data-id');
			if (!id) {
				return false;
			}

			const data = {
				action: 'remove_single_compare',
				id
			};
			document.body.classList.add('ajax-custom-action');
			CompareProducts.ajaxFunctionRemove(data);
		};

		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', removeSingle);
		}
	},

	removeAll: function() {
		const btn = document.querySelector('.js-remove-all-compare');

		if (!btn) {
			return false;
		}

		const removeAllFromCompare = function() {
			const data = {
				action: 'remove_all_compare',
			};
			document.body.classList.add('ajax-custom-action');
			CompareProducts.ajaxFunctionRemove(data);
		};

		btn.addEventListener('click', removeAllFromCompare);
	},

	ajaxFunctionRemove: function(data) {
		$.ajax({
			datatype: 'json',
			type: 'POST',
			url: window.techno_ferum_ajax.ajax_url,
			data,
			success: function(response) {
				if (response.success) {
					if ($('.js-compare-block').length > 0) {
						$('.js-compare-block').replaceWith(response.data.products);
					}
					$('.js-products-compare__bar').replaceWith(response.data.banner);
				}
				document.body.classList.remove('ajax-custom-action');
				CompareProducts.removeFromCompareBar();
				CompareProducts.removeSingleProduct();
				CompareProducts.removeAll();
			}
		});
	},

	ajaxFunction: function() {
		const data = {
			action: 'generate_compare',
			ids: compareIds
		};
		$.ajax({
			datatype: 'json',
			type: 'POST',
			/* eslint-disable */
			url: techno_ferum_ajax.ajax_url,
			/* eslint-disable */
			data,
			success: function(response) {
				if (response.success) {
					$('.js-products-compare__bar').replaceWith(response.data);
				}
				document.body.classList.remove('ajax-custom-action');
				CompareProducts.removeFromCompareBar();
			}
		});
	}
};

export default CompareProducts;
